export const NODE_ENV = import.meta.env.VITE_NODE_ENV;

export const API_URL =
  NODE_ENV === 'development' ? import.meta.env.VITE_DEV_API : import.meta.env.VITE_PROD_API;

export const B2B_PORTAL_URL =
  NODE_ENV === 'development' ? import.meta.env.VITE_DEV_B2B_URL : import.meta.env.VITE_PROD_B2B_URL;

export const SITE_URL =
  NODE_ENV === 'development'
    ? import.meta.env.VITE_DEV_SITE_URL
    : import.meta.env.VITE_PROD_SITE_URL;

export const AUTO_ACCEPT_COOKIE_CONSENT =
  import.meta.env.VITE_AUTO_ACCEPT_COOKIE_CONSENT === 'true';
